import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const ShowInfo = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  const openModal = () => {
    setCurrentPage(0);
    setIsOpen(true);
  };

  const closeModal = () => setIsOpen(false);

  const goNext = () => {
    if (currentPage < data.length - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goPrev = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div>
      <button
        onClick={openModal}
        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition button_orange"
      >
        Planspiel Tipps
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="modal-backdrop"  // Custom backdrop class
          >
            <motion.div
              initial={{ y: 100, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 100, opacity: 0 }}
              transition={{ type: "spring", stiffness: 300, damping: 25 }}
              className="modal-content-info" // Custom modal content class
            >
              <button
                onClick={closeModal}
                className="close-button" // Custom close button class
              >
                ✕
              </button>

              <h4 className="text-2xl font-bold text-blue-700 mb-4">Planspiel Tipps</h4>

              {data && data.length > 0 ? (
                <div>
                  <div className="mb-6">
                    <span className="text-gray-800 text-lg leading-relaxed">
                      {data[currentPage].infoname}
                    </span>
                  </div>

                  <div className="flex justify-between items-center mt-4">
                    <button
                      onClick={goPrev}
                      disabled={currentPage === 0}
                      className="button_orange bg-gray-200 rounded-lg hover:bg-gray-300 transition disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      ← 
                    </button>

                    <span className="pagination text-sm text-gray-500">
                      {currentPage + 1} of {data.length}
                    </span>

                    <button
                      onClick={goNext}
                      disabled={currentPage === data.length - 1}
                      className="button_orange bg-gray-200 rounded-lg hover:bg-gray-300 transition disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      →
                    </button>
                  </div>
                </div>
              ) : (
                <p className="text-red-500">Data missing ShowInfo</p>
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
